module.exports = __webpack_public_path__ + "img/facade-classic-double.f4494113.jpeg";